import styles from "./Footer.module.css";
import React from "react";
import twitter from "../../media/twitter.webp"
import discord from "../../media/discord.webp"
import mirror from "../../media/mirror.webp"
import SectionSeparator from "../sectionSeparator/SectionSeparator"

const Footer = (props) => {
    return (
        <div className={styles.footer_wrapper}>
            <SectionSeparator/>
            <div>
                <a href="https://twitter.com/yium_e" className="main" target="_blank">
                    <img src={twitter} className={styles["social"]} alt="Twitter link"/>
                </a>
                <a href="https://discord.gg/r6tPQDUZA7" className="main" target="_blank">
                    <img src={discord} className={styles["social"]} alt="Discord link"/>
                </a>
                <a href="https://mirror.xyz/0x5094e2aAf34C608FAbC482eb7E1d1474dfDE0ad4/DUlCTYB__-XcXny7aA8TWp9Mb_J9pZiH7zs8JWhxZK0" className="main" target="_blank">
                    <img src={mirror} className={styles["social"]} alt="Mirror link"/>
                </a>
            </div>
        </div>
    );
};

export default Footer;
